import script from "./AboutPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPreview.vue?vue&type=script&setup=true&lang=js"

import "./AboutPreview.vue?vue&type=style&index=0&id=f33bb3ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33bb3ce"]])

export default __exports__